<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('history') }} </v-toolbar-title>
      <v-chip
        label
        outlined
        color="green"
        class="mx-2"
      >
        {{ $t('check') }} {{$t(checkItem.type)}}
      </v-chip>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="statusTrackDialog = !statusTrackDialog"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-history
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('history') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <v-chip
              label
              outlined
              color="primary"
              style="width: 100%"
            >
              {{$t('name')}}  {{$t('account')}}:  {{checkItem.account.name}}
            </v-chip>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <v-chip
              label
              outlined
              color="primary"
              style="width: 100%"
            >
              {{$t('amount')}}  {{$t('check')}}:  {{$numberFormat(checkItem.amount)}} {{checkItem.currency.symbol}}
            </v-chip>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <v-chip
              label
              outlined
              color="primary"
              style="width: 100%"
            >
              {{$t('number')}}  {{$t('check')}}:  {{checkItem.number}}
            </v-chip>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <v-chip
              label
              outlined
              color="primary"
              style="width: 100%"
            >
              {{$t('name')}}  {{$t('bank')}}:  {{(checkItem.type == 'own' ? checkItem.bank.name + '-' + checkItem.bank.number : checkItem.bank_name + '-' + checkItem.bank_account_number )}}
            </v-chip>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-select
              v-model="status"
              :label="$t('status')"
              :items="statusItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
              item-disabled="disable"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <template>
              <v-text-field
                id="from"
                v-model="date"
                :label="$t('date')"
                :rules="[v => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="date"
                element="from"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            v-if="type == 'customer'"
            cols="12"
            sm="3"
            md="3"
          >
            <autocomplete
              ref="refBank"
              v-model="bank"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('account')"
              type="allBankCash"
              :disabled="(status == 'bank' || status == 'passed' ? false : true)"
              :value="bank"
            />
          </v-col>
          <v-col
            v-if="checkItem.type == 'own'"
            cols="12"
            sm="3"
            md="3"
          >
            <v-chip
            label
            outlined
            color="blue"
            >
              {{$t('remain')}} {{$t('bank')}} :  {{(checkItem.bank.remain ? $numberFormat(checkItem?.bank?.remain?.currency_remain) + ' ' + checkItem.bank.remain.currency.symbol : 0 )}}
            </v-chip>
            <v-chip
              v-if="parseFloat(checkItem?.bank?.remain?.currency_remain) < parseFloat(Number(checkItem.amount))"
              label
              outlined
              color="pink"
              class="mx-2"
            >
              <v-icon left>
                mdi-alert
              </v-icon>
              {{$t('inventoryShortage')}}
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="checkItem.status.status !== status"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="statusTrackDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="statusTrackDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('status') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <statusTrack
            :check="checkItem"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  import statusTrack from './checkStatusTrack'
  export default {
    name: 'Product',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      statusTrack,
    },
    mixins: [General],
    props: ['checkItem'],
    data: () => ({
      render: false,
      statusTrackDialog: false,
      isLoading: false,
      alert: false,
      changeStatus: true,
      item: null,
      date: null,
      bank: null,
      valid: null,
      message: null,
      alertType: null,
      itemDisabled: null,
      id: null,
      statusItems: [],
      currency_amount: null,
      account: null,
      type: null,
      status: null,
      loading: false,
    }),
    watch: {
      checkItem () {
        this.render = false
        this.statusItems = []
        if (this.$refs.refBank) {
          this.$refs.refBank.clear()
          this.$refs.refBank.initList = false
          this.$refs.refBank.getItems({ query: null, page: 1 })
        }
        this.show()
      },
    },
    beforeMount () {
      this.render = false
    },
    mounted () {
      this.render = true
      if (this.checkItem) {
        this.show()
      }
    },
    methods: {
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'checks/' + this.checkItem.id, this.$data)
          .then(res => {
            res = res.data
            this.$emit('input', res.data)
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      show () {
        this.$nextTick(() => {
          this.item = this.checkItem
          this.type = this.checkItem.type
          var passedDisabled = true
          if (this.checkItem.type === 'own' && parseFloat(this.checkItem?.bank?.remain?.currency_remain) >= parseFloat(Number(this.checkItem.amount))) {
            passedDisabled = false
          }
          if (this.checkItem.type === 'own') {
            this.statusItems = [
              {
                value: 'issued',
                text: this.$t('issued'),
              },
              {
                value: 'returned',
                text: this.$t('returned'),
              },
              {
                value: 'passed',
                text: this.$t('passed'),
                disable: passedDisabled,
              },
              {
                value: 'canceled',
                text: this.$t('canceled'),
              },
            ]
          } else {
            var payedDisable = false
            if (this.checkItem.status.status === 'payed' || this.checkItem.status.status === 'passed' || this.checkItem.kind === 'guarantee') {
              payedDisable = true
            }
            this.statusItems = [
              {
                value: 'fund',
                text: this.$t('fund'),
              },
              {
                value: 'bank',
                text: this.$t('inBank'),
                disable: payedDisable,
              },
              {
                value: 'returned',
                text: this.$t('returned'),
                disable: payedDisable,
              },
              {
                value: 'passed',
                text: this.$t('passed'),
                disable: payedDisable,
              },
              {
                value: 'canceled',
                text: this.$t('canceled'),
                disable: payedDisable,
              },
              {
                value: 'payed',
                text: this.$t('payed'),
                disable: true,
              },
            ]
          }
          this.bank = this.checkItem.status.bank
          this.status = this.checkItem.status.status
          this.date = this.checkItem.status.date
          this.render = true
        })
      },
    },
  }
</script>

<style scoped>

</style>
